
"use client";

import React, { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { useSiteStatus } from '@/contexts/SiteStatusContext';
import MaintenancePage from '@/components/layout/MaintenancePage';
import { SiteStatusBanner } from '@/components/layout/SiteStatusBanner';
import { AppFooter } from '@/components/layout/AppFooter'; // Import the new footer
import { Loader2 } from 'lucide-react'; 

export default function AppContentWrapper({ children }: { children: ReactNode }) {
  const { maintenanceModeActive, loadingStatus } = useSiteStatus();
  const pathname = usePathname();

  const isAdminPath = pathname.startsWith('/admin');
  const isLoginPath = pathname.startsWith('/login');

  if (loadingStatus) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
        <p className="mt-4 text-muted-foreground">Loading application status...</p>
      </div>
    );
  }

  const showMaintenance = maintenanceModeActive && !isAdminPath && !isLoginPath;

  if (showMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <>
      <SiteStatusBanner />
      {/* The main content (children) will be rendered here */}
      {children}
      {/* AppFooter is rendered after the children, making it appear at the bottom */}
      <AppFooter />
    </>
  );
}
